module.exports = __webpack_public_path__ + "img/logo.65c949ce.png";